import {
  IBeautyPlaceData,
  IContactWayData,
  IFaqItemData,
  IListResponse,
  INewsData,
  INews,
  IBeautyPlace,
  IPartnerData
} from '@/entities'
import {
  IInfoService
} from './index'
import {
  AxiosInstance,
  AxiosResponse
} from 'axios'
import {
  defaultConfig
} from '../config'


export class InfoService implements IInfoService {
  constructor(private readonly axios: AxiosInstance) {}

  async getAllPartners(language?: string): Promise<AxiosResponse<IListResponse<IPartnerData[]>>> {
    return this.axios.get('/partners/', defaultConfig(language))
  }
  async getPartnerById(id: number, language?: string): Promise<AxiosResponse<IPartnerData | undefined>> {
    return this.axios.get(`/partners/${ id }/`, defaultConfig(language))
  }

  async getAllContactWays(language?: string): Promise<AxiosResponse<IListResponse<IContactWayData[]>>> {
    return this.axios.get('/contact_way/', defaultConfig(language))
  }
  async getContactWayById(id: number, language?: string): Promise<AxiosResponse<IContactWayData | undefined>> {
    return this.axios.get(`/contact_way/${ id }/`, defaultConfig(language))
  }

  async getAllFaqItems(language?: string): Promise<AxiosResponse<IListResponse<IFaqItemData[]>>> {
    return this.axios.get('/faq_items/', defaultConfig(language))
  }
  async getFaqItemById(id: number, language?: string): Promise<AxiosResponse<IFaqItemData | undefined>> {
    return this.axios.get(`/faq_items/${ id }/`, defaultConfig(language))
  }

  async getAllNews(language?: string | undefined): Promise<AxiosResponse<IListResponse<INewsData[]>>> {
    return this.axios.get('/news/', defaultConfig(language))
  }
  async getNewsById(id: number, language?: string): Promise<AxiosResponse<INews | undefined>> {
    return this.axios.get(`/news/${ id }/`, defaultConfig(language))
  }

  async getAllBeautyPlaces(language?: string | undefined): Promise<AxiosResponse<IListResponse<IBeautyPlaceData[]>>> {
    return this.axios.get('/beautiful_place/', defaultConfig(language))
  }
  async getBeautyPlaceById(id: number, language?: string): Promise<AxiosResponse<IBeautyPlace | undefined>> {
    return this.axios.get(`/beautiful_place/${ id }/`, defaultConfig(language))
  }

}
